import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { JaldeeVerifyLevelService } from 'src/app/services/jaldee-verify-level.service';

@Component({
  selector: 'app-jaldee-verify-level',
  templateUrl: './jaldee-verify-level.component.html',
  styleUrls: ['./jaldee-verify-level.component.css']
})
export class JaldeeVerifyLevelComponent implements OnInit {
  routeLinks: any[];
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private location: Location,
    private jaldeeService: JaldeeVerifyLevelService) {

    this.routeLinks = [
      {
          label: 'UPDATE JALDEE VERIFY LEVEL',
          link: './update',
          index: 0
      }, {
          label: 'VERIFICATION HISTORY',
          link: './log',
          index: 1
      }
  ];
  }

  ngOnInit() {
  }
  goBacktoList() {
    console.log('type.....' + this.jaldeeService.getTypeofAccount());
    // this.location.back();
  if (this.jaldeeService.getTypeofAccount() === 'corporate') {
    this.router.navigate(['../../corporates/list'], { relativeTo: this.activatedRoute });
  } else if (this.jaldeeService.getTypeofAccount() === 'account') {
         this.router.navigate(['../filter/list'], { relativeTo: this.activatedRoute });
  }

}
}
